import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
 
const expandAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate(0, 0) scale(0.5);
  }
  100% {
    opacity: 1;
    transform: translate(var(--translate-x), var(--translate-y)) scale(1);
  }
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 400px;
  background-color: transparent;
  z-index: 10002;
`;

const MenuItem = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform-origin: 0 0;
  font-size: ${({ fontSize }) => fontSize}px; /* フォントサイズを動的に変更 */
  color: white;
  opacity: 0;
  font-family: 'Nanum Myeongjo', serif;

  animation: ${expandAnimation} 0.5s ease forwards;
  animation-delay: ${({ delay }) => delay}s;

  --translate-x: ${({ x }) => x}px;
  --translate-y: ${({ y }) => y}px;
  transform: translate(var(--translate-x), var(--translate-y)) rotate(${({ angle }) => -angle}deg);

  & > span {
    transform: rotate(${({ angle }) => angle}deg);
    display: block;
  }
`;


const SideMenu = ({ isOpen,isSettingClicked, onSettingClick }) => {
  const [items, setItems] = useState([]);
  const [radius, setRadius] = useState(300); // 初期値
  const [fontSize, setFontSize] = useState(18); // 初期フォントサイズ
  // const [isSettingClicked, setIsSettingClicked] = useState(false);
  // const [isSliderVisible, setIsSliderVisible] = useState(false); // スライダー表示状態
  const navigate = useNavigate();

  const contentLabels = { "MEMBER": 95, "DATA": 120, "USER GUIDE": 135, "SETTING": 155, "HOME": 175};

  useEffect(() => {
    // 初期メニューアイテムの計算
    const updateResponsiveValues = () => {
      const newRadius = Math.min(window.innerWidth, window.innerHeight) * 0.3; // 半径を画面サイズに依存
      const newFontSize = Math.min(window.innerWidth, window.innerHeight) * 0.02; // フォントサイズを画面サイズに依存
      setRadius(newRadius);
      setFontSize(newFontSize);

      const initialItems = Object.entries(contentLabels).map(([label, angle]) => {
        const angleInRadians = (angle * Math.PI) / 180;
        const x = newRadius * Math.cos(angleInRadians);
        const y = newRadius * Math.sin(angleInRadians);

        return {
          label,
          x,
          y,
          angle,
        };
      });

      setItems(initialItems);
    };

    updateResponsiveValues(); // 初期化時に呼び出し

    window.addEventListener("resize", updateResponsiveValues); // リサイズイベントで更新
    return () => window.removeEventListener("resize", updateResponsiveValues); // クリーンアップ
  }, []);

const handleItemClick = (label) => {
    if (label === "SETTING") {
      onSettingClick(!isSettingClicked); // 状態を反転させて親に渡す
    } else if (label === "DATA") {
      window.open("/useageData.html", "_blank", "noopener,noreferrer");
    } else if (label === "MEMBER") {
      window.open("/member.html", "_blank", "noopener,noreferrer");
    } else if (label === "USER GUIDE"){
      window.open("https://docs.google.com/presentation/d/1WlRi3Jgo50tBvJK4wg_ruzR9jd304NxD9aebzR0Gcas/edit?usp=sharing", "_blank", "noopener,noreferrer");
    } else if (label === "HOME") {
      window.location.href = "/";
    }
  };

  return (
    <div>
      <MenuContainer>
        {isOpen &&
          items.map((item, index) => (
            <MenuItem
              key={index}
              x={item.x}
              y={item.y}
              angle={item.angle - 180}
              delay={index * 0.1}
              fontSize={fontSize} // フォントサイズを渡す
              onClick={() => handleItemClick(item.label)} // クリックイベントハンドラを設定
            >
              <span>{item.label}</span>
            </MenuItem>
          ))}
      </MenuContainer>
      <button>
          jump to tama
      </button>
    </div>
  );
};

export default SideMenu;
